import type { Material } from '#domain/Material.ts';
import type { Stop } from '#domain/Stop.ts';

export type OrderType = 'transport' | 'service';

export type OrderStatus = 'open' | 'planned' | 'in-transit' | 'loading' | 'unloading' | 'executing' | 'finished';

export type OrderTruck = {
    id: string;
    name?: string;
    hasOrderCommunicationLicense?: boolean;
    hasPocketDriverDataSource?: boolean;
};

type BaseOrderSummary = {
    id: string;
    number: string;
    customerName: string;
    status?: OrderStatus;
    tourId?: string;
    tourName?: string;
    truck?: OrderTruck;
    customerOrderId?: string;
};

export type TransportOrderSummary = BaseOrderSummary & {
    type?: 'transport';
    loadingStop: Stop;
    unloadingStop: Stop;
    loadingComment?: string;
    unloadingComment?: string;
    materials?: Material[];
};

export type ServiceOrderSummary = BaseOrderSummary & {
    type: 'service';
    executionStop: Stop;
    description: string;
    note?: string;
};

export type OrderSummary = TransportOrderSummary | ServiceOrderSummary;

export type TransportOrderDetails = TransportOrderSummary & {
    materials?: Material[];
};

export type ServiceOrderDetails = ServiceOrderSummary;

export type OrderDetails = TransportOrderDetails | ServiceOrderDetails;

export const isTransportOrder = (order: OrderSummary): order is TransportOrderSummary => order.type !== 'service';
export const isServiceOrder = (order: OrderSummary): order is ServiceOrderSummary => order.type === 'service';
